export default __webpack_public_path__ + "static/media/white font banner.b3af3c22.png";